import { render, staticRenderFns } from "./jianyerenminzhengfu.vue?vue&type=template&id=3cc49778&scoped=true&"
import script from "./jianyerenminzhengfu.vue?vue&type=script&lang=js&"
export * from "./jianyerenminzhengfu.vue?vue&type=script&lang=js&"
import style0 from "./jianyerenminzhengfu.vue?vue&type=style&index=0&id=3cc49778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc49778",
  null
  
)

export default component.exports